import { Injectable } from '@angular/core';
import { UserGioLocation } from '../../models/user/usergioLocation';
import { geolocation } from '../../sharedcomponents/commonservice/geolocation/geoloc';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';

@Injectable()
export class PayagainorderService {
  userGioLocation: UserGioLocation;
  constructor(private geoloc: geolocation, private utilserv: utilityService) {}

  payrepayTransactionservice(repayTrans, fundingID) {
    return this.utilserv.soapPostwithoutAction(this.payailedtransactionlistenvolpe(repayTrans, fundingID), AppSettings.OrderProcessingService);
  }
  payailedtransactionlistenvolpe(repayTrans, fundingID) {
    this.userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      this.userGioLocation = data;
    });
    const getOrderID = this.getOrderString(repayTrans.orderList);
    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                                                                                  <s:Header>
                                                                                    <a:Action s:mustUnderstand="1">http://tempuri.org/IOrderProcessingService/RePayment</a:Action>
                                                                                    <a:MessageID>urn:uuid:a50a4f35-c39d-4220-8e84-1ca5fe5f2d2d</a:MessageID>
                                                                                    <a:ReplyTo>
                                                                                      <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                                                                                    </a:ReplyTo>
                                                                                  </s:Header>
                                                                                  <s:Body>
                                                                                    <PaymentRequest xmlns="http://tempuri.org/">
                                                                                      <Currency>USD</Currency>
                                                                                      <EndUserLatitude>${this.userGioLocation.latitude}</EndUserLatitude>
                                                                                      <EndUserLongitude>${this.userGioLocation.longitude}</EndUserLongitude>
                                                                                      <EndUserIP>${sessionStorage.EndUserIP}</EndUserIP>
                                                                                      <EntryType>${AppSettings.Platform}</EntryType>
                                                                                      <FundingId>${fundingID}</FundingId>
                                                                                      <Items xmlns:d4p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                                                                         ${getOrderID}
                                                                                      </Items>
                                                                                      <LanguageCode>en</LanguageCode>
                                                                                      <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.OrderProcessing.Contracts.DataContracts.Soap" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                                                                        <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                                                                                        <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                                                                                      </Session>
                                                                                      <TotalAmount>${repayTrans.totalAmount}</TotalAmount>
                                                                                    </PaymentRequest>
                                                                                  </s:Body>
                                                                                </s:Envelope>`;

    return envelope;
  }
  getOrderString(orderList) {
    let orderstr = '';
    orderList.forEach(element => {
      orderstr += `<d4p1:int>${element}</d4p1:int>`;
    });
    return orderstr;
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/transaction/payagain-repaydorder.service.ts